import { DEFECT_ESTIMATED_COSTS } from "@idwal/idwal-utilities/lib/types/DefectEstimatedCosts";
import { Defect } from "../../types/defect";

export const EstimateCostBody = (defect: Defect) => {
    const estimateDefectCost = DEFECT_ESTIMATED_COSTS.find((cost) => cost.id === defect.estimateDefectCostRangeId);

    if (!estimateDefectCost) {
        return null;
    }

    return <div>{estimateDefectCost.label}</div>
};
